import PropTypes from 'prop-types';
import {maps as gmaps} from 'google';

export const SEARCH_TYPE = PropTypes.oneOf([
    'address',
    'destination',
    'event',
    'venue',
    'city'
]);

export const GOOGLE_MAPS_LAT_LNG = PropTypes.instanceOf(gmaps.LatLng);
